import { useQuery } from "@tanstack/react-query";
import {
  NaceSectionBasicDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_NACE } from "../domain";

import { naceApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_NACE_SECTIONS = "GET_NACE_SECTIONS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getNaceSections = async (): Promise<NaceSectionBasicDto[]> => {
  const response = await naceApi.naceControllerGetNaceSections();

  return response.data;
};

export const useGetNaceSections = (
  user: UserProfileDto | null,
): {
  naceSections: NaceSectionBasicDto[];
  naceSectionsEnabled: boolean;
  isPendingGetNaceSections: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isPending, data = [] } = useQuery({
    queryKey: [DOMAIN_NACE, ACTION_GET_NACE_SECTIONS],
    queryFn: () => getNaceSections(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    naceSections: data,
    naceSectionsEnabled: enabled,
    isPendingGetNaceSections: isPending,
  };
};
